// src/pages/Home.js (or wherever your Home component is)
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import photo1 from './images/bg.avif';
import './Home.css';

import photo2 from './images/2.jpg';
import photo3 from './images/3.jpg';
import photo4 from './images/4.webp';
import photo5 from './images/5.webp';
import photo6 from './images/6.webp';
import photo7 from './images/9.webp';
import { FaPills, FaHeartbeat, FaTooth, FaThermometerHalf } from 'react-icons/fa';

const Home = () => {
  const navigate = useNavigate();

  const handleShopNowClick = () => {
    const user = JSON.parse(localStorage.getItem('currentUser')) || JSON.parse(localStorage.getItem('loggedInUser'));
if (user && user.email) {
  navigate('/medicines');
} else {
  navigate('/login');
}
  };

  return (
    <div>
      <div className="hero-section">
  <div className="hero-overlay"></div>
  <div className="hero-content">
    <h1 className="display-4 fw-bold">Welcome to Pharmacart</h1>
    <p className="lead">Your trusted shop for online medicines</p>
    <Button variant="outline-light" size="lg" onClick={handleShopNowClick}>
      Shop Now
    </Button>
  </div>
</div>
      {/* Featured Categories */}
<div className="container my-5">
  <h3 className="text-center mb-4">Popular Categories</h3>
  <div className="row text-center">
    <div className="col-md-3 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <FaPills size={40} className="mb-3 text-success" />
          <h5 className="card-title">Medicines</h5>
          <p className="card-text">Pain relief, fever, antibiotics & more.</p>
          <a href="/medicines" className="btn btn-success mt-3">Know More</a>
        </div>
      </div>
    </div>
    <div className="col-md-3 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <FaHeartbeat size={40} className="mb-3 text-success" />
          <h5 className="card-title">Wellness</h5>
          <p className="card-text">Vitamins, supplements, protein & more.</p>
          <a href="/wellness" className="btn btn-success mt-3">Know More</a>
        </div>
      </div>
    </div>
    <div className="col-md-3 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <FaTooth size={40} className="mb-3 text-success" />
          <h5 className="card-title">Personal Care</h5>
          <p className="card-text">Skin, hair, oral hygiene products.</p>
          <a href="/personal" className="btn btn-success mt-3">Know More</a>
        </div>
      </div>
    </div>
    <div className="col-md-3 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <FaThermometerHalf size={40} className="mb-3 text-success" />
          <h5 className="card-title">Devices</h5>
          <p className="card-text">Thermometers, oximeters, BP monitors.</p>
          <a href="/devices" className="btn btn-success mt-3">Know More</a>
        </div>
      </div>
    </div>
  </div>
</div>
{/* Discounted Products */}
<div className="container my-5">
  <h3 className="text-center mb-4">Discounted Products</h3>
  <div className="row">
  <div className="col-md-3 mb-4">
  <div className="card h-100 d-flex flex-column">
    <img src={photo4} className="card-img-top" alt="Paracetamol" />
    <div className="card-body d-flex flex-column">
      <h5 className="card-title">Depura Vitamin D3 60k Sugar Free Oral Solution 5ml</h5>
      <p className="card-text text-muted"><del>₹50</del> <span className="text-success fw-bold">₹35</span></p>
      <a href={`/medicines/4`} className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
    </div>
  </div>
</div>

    <div className="col-md-3 mb-4">
      <div className="card h-100 d-flex flex-column">
        <img src={photo5} className="card-img-top" alt="Multivitamins" />
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">Evion 400mg Strip Of 20 Capsule</h5>
          <p className="card-text text-muted"><del>₹200</del> <span className="text-success fw-bold">₹150</span></p>
          <a href="/medicines/2" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
        </div>
      </div>
    </div>

    <div className="col-md-3 mb-4">
      <div className="card h-100 d-flex flex-column">
        <img src={photo6} className="card-img-top" alt="Thermometer" />
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">Complan Viemax Chocolate Flavour Refill 200gm </h5>
          <p className="card-text text-muted"><del>₹300</del> <span className="text-success fw-bold">₹220</span></p>
          <a href="/medicines/6" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
        </div>
      </div>
    </div>

    <div className="col-md-3 mb-4">
      <div className="card h-100 d-flex flex-column">
        <img src={photo7} className="card-img-top" alt="Facewash" />
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">Hashmi Hard Rock Boost Energy Capsule 20</h5>
          <p className="card-text text-muted"><del>₹120</del> <span className="text-success fw-bold">₹90</span></p>
          <a href="/medicines/5" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
        </div>
      </div>
    </div>
  </div>
</div>


            {/* Why Choose Us */}
            <div className="bg-light py-5">
        <div className="container">
          <h3 className="text-center mb-4">Why Choose PharmaCart?</h3>
          <div className="row text-center">
            <div className="col-md-4">
              <h5>Trusted Products</h5>
              <p>Only certified medicines & healthcare brands.</p>
            </div>
            <div className="col-md-4">
              <h5>Fast Delivery</h5>
              <p>Get medicines at your doorstep within 24-48 hours.</p>
            </div>
            <div className="col-md-4">
              <h5>Secure Payments</h5>
              <p>Multiple secure payment options for hassle-free shopping.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
